<div class="modal-content">
  <div class="modal-header">
    <h4 style="max-width: 80% !important;"><strong> {{ heading }} </strong></h4>
    <button type="button" class="close help-icon" (click)="helpBtnClicked()">
      <fa-icon [icon]="['far', 'question-circle']" size="lg">  </fa-icon>
    </button>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef.close()">
      <fa-icon [icon]="['far', 'times-circle']" size="lg">  </fa-icon>
    </button>
  </div>
  <div class="modal-body our-form-background">
    <ng-content></ng-content>
  </div>

  <div class="modal-footer">
    <div *ngIf="!buttonsDisabled">
      <button type="button" *ngIf="isEditing" pButton class="relative waves-light eca-btn p-button"
              [ngClass]="'eca-btn-' + noButtonColour" (click)="cancelBtnClicked()">
        <span >{{noButtonText}}</span>
        <fa-icon style="margin-left: 10px" [icon]="noButtonIcon" size="lg" *ngIf="noButtonIcon"></fa-icon>
      </button>
      <button type="button" *ngIf="isEditing && showSaveAndUploadButton" pButton
              class="relative waves-light eca-btn"
              [ngClass]="'eca-btn-' + showSaveAndUploadButtonColor"
              (click)="saveAndUploadBtnClicked()">
        <span>{{saveAndUploadButtonText}}</span> <fa-icon style="margin-left: 10px" [icon]="showSaveAndUploadButtonIcon" size="lg" *ngIf="showSaveAndUploadButtonIcon"></fa-icon>
      </button>
      <button type="button" *ngIf="isEditing" pButton
              class="relative waves-light eca-btn"
              [ngClass]="'eca-btn-' + yesButtonColour"
              (click)="clicked(true)">
        <span >{{yesButtonText}}</span>  <fa-icon style="margin-left: 10px" [icon]="yesButtonIcon" size="lg" *ngIf="yesButtonIcon"></fa-icon>
      </button>
      <button type="button" *ngIf="!isEditing && showExportToPDFButton" pButton class="relative waves-light eca-btn"
              [ngClass]="'eca-btn-' + noButtonColour"  printTitle="EAS Guidance"
              printSectionId="dataToPrint"  [useExistingCss]="true"
              ngxPrint>
        <span >Print</span>   <fa-icon style="margin-left: 10px" [icon]="printIcon" size="lg" *ngIf="closeButtonIcon"></fa-icon>
      </button>
      <button type="button" *ngIf="!isEditing" pButton class="relative waves-light eca-btn"
              [ngClass]="'eca-btn-' + noButtonColour" (click)="closeBtnClicked()">
        <span >{{closeButtonText}}</span> <fa-icon style="margin-left: 10px" [icon]="closeButtonIcon" size="lg" *ngIf="closeButtonIcon"></fa-icon>
      </button>
      <button type="button" *ngIf="!isEditing && (editButtonText || editButtonIcon) && !isReadOnly"
              pButton
              [ngClass]="'eca-btn-' + editButtonColour"
              class="relative waves-light eca-btn"
              (click)="editBtnClicked()">
        <span >{{editButtonText}}</span> <fa-icon style="margin-left: 10px" [icon]="editButtonIcon" size="lg" *ngIf="editButtonIcon"></fa-icon>
      </button>
    </div>
  </div>
</div>
